import React, {FC} from 'react'

interface Props {
  /** What is happening, under the spinner ("Deleting 12 teachers…"). */
  label: string
  isDark: boolean
}

/**
 * One spinner over a whole table while a bulk action runs on it (deleting the selected rows),
 * instead of one per row. The parent must be `position: relative`; the rows beneath stay visible
 * but can't be clicked until it is gone.
 */
const TableBusyOverlay: FC<Props> = ({label, isDark}) => (
  <div
    role='status'
    aria-live='polite'
    style={{
      position: 'absolute',
      inset: 0,
      zIndex: 5,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.75rem',
      background: isDark ? 'rgba(15, 16, 22, 0.6)' : 'rgba(255, 255, 255, 0.7)',
      borderRadius: 'inherit',
    }}
  >
    <span className='spinner-border text-primary' aria-hidden='true' />
    <span style={{fontWeight: 600, color: isDark ? '#e4e6ef' : '#181C32'}}>{label}</span>
  </div>
)

export default TableBusyOverlay
